<template>
  <div>
    <TextField v-if="!settings.options" label="Value" :value="value" @input="$emit('input', $event)" />
    <Multiselect v-else :value="value" label="Value" :options="settings.options" @input="$emit('input', $event)" />
  </div>
</template>
<script>
import TextField from '@/components/common/TextField.vue';
import Multiselect from '@/components/common/Multiselect.vue';
export default {
  components: {
    TextField,
    Multiselect
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    settings: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
